import emailjs from "./emailjsWithFallback";
import dayjs from "dayjs";
import ENV from "../env.js";
import { auth } from "../firebase";

export const sendQRCode = async ({ templateId, props }) => {
  const response = await emailjs.send(
    ENV.emailJsServiceId,
    templateId ? templateId : "template_bmpkuw6",
    props,
    "user_Io6hQDXLobAbA5jUwZICt",
  );

  return response;
};

export const sendMarketplaceRequest = async (formData, items = []) => {
  const uniqueProviderIds = [...new Set(items.map((i) => i.providerId))];

  const emailPromises = uniqueProviderIds.map(async (providerId) => {
    const providerItems = items.filter((i) => i.providerId === providerId);
    const { providerName, email } = providerItems[0];

    const templateParams = {
      email: email,
      serviceTitle: providerItems.map((i) => i.name).join(", "),
      serviceName: providerName,
      products: providerItems.map((i) => `${i.quantity} ${i.name}\n`),
      customerName: formData.contactLastName,
      customerFirstName: formData.contactFirstName,
      customerPhoneNumber: formData.phone,
      customerEmail: formData.email,
      customerOrgName: formData.companyName,
      invoiceAdress: formData.invoiceAddress,
      eventAddress: formData.eventAddress,
      eventType: formData.eventType,
      eventStartDate: dayjs(formData.startDate).format("DD/MM/YYYY"),
      eventEndDate: dayjs(formData.endDate).format("DD/MM/YYYY"),
      message: formData.request,
    };

    return emailjs.send(
      ENV.emailJsServiceId,
      "template_hx8ibup",
      templateParams,
      "user_Io6hQDXLobAbA5jUwZICt",
    );
  });

  return Promise.all(emailPromises);
};

export const sendTicketingBroadcastEmail = async ({ templateId, props }) => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error("Authentication required");
  const response = await fetch(`${ENV.firebaseApiUrl}/mail/send-ticketing-broadcast`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      templateId: templateId || ENV.emailJsTicketingBroadcastTemplateId,
      ...props,
    }),
  });

  const data = await response.json();

  if (!response.ok && response.status !== 207) {
    const error = new Error(data?.message || "Ticketing broadcast email failed");
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
};
